<template>
    <div class="sb_dev_nav">
        <select v-model="vestigingId" class="sb_dev_nav__select">
            <option v-for="gym in gyms" :key="gym.id" :value="gym.id">
                {{ gym.name }} ({{ gym.id }})
            </option>
        </select>
        <nav class="sb_dev_nav__links">
            <router-link v-for="screen in screens" :key="screen" :to="to(screen)">
                {{ screen }}
            </router-link>
        </nav>
    </div>
</template>

<script>
import { getGyms } from '@/lib/backend';

const LAST_VESTIGING_KEY = 'pfg_dev_vestiging';

export default {
    name: 'dev-navigator',
    data() {
        return {
            gyms: [],
            vestigingId: +localStorage.getItem(LAST_VESTIGING_KEY) || null
        };
    },
    computed: {
        screens() {
            return this.$router.options.routes
                .filter(route => route.path !== '/')
                .map(route => route.name);
        }
    },
    watch: {
        vestigingId(id) {
            localStorage.setItem(LAST_VESTIGING_KEY, id);
        }
    },
    async mounted() {
        try {
            const gyms = await getGyms();
            this.gyms = gyms.sort((a, b) => a.name.localeCompare(b.name));
        } catch (error) {
            console.error('Could not load the gyms', error);
        }
        const isKnown = this.gyms.some(gym => gym.id === this.vestigingId);
        if (!isKnown && this.gyms.length) {
            this.vestigingId = this.gyms[0].id;
        }
    },
    methods: {
        to(name) {
            return { name, query: { vestiging: this.vestigingId } };
        }
    }
};
</script>

<style lang="scss" scoped>
.sb_dev_nav {
    position: fixed;
    left: 50%;
    bottom: $default-padding;
    transform: translateX(-50%);
    display: flex;
    padding: 10px;
    border-radius: $default-border-radius;
    background: rgba($brand-white, 0.9);
    box-shadow: $default-box-shadow;
    font-size: 1.6rem;
}

.sb_dev_nav__select {
    padding: 8px 10px;
    border: $default-border;
    border-radius: $default-border-radius;
    background: $brand-white;
    color: $default-text-color;
    font-size: inherit;
}

.sb_dev_nav__links {
    display: flex;

    a {
        display: flex;
        align-items: center;
        margin-left: 5px;
        padding: 8px 16px;
        border-radius: $default-border-radius;
        background: $brand-secondary;
        color: $brand-white;
        text-decoration: none;
        text-transform: capitalize;

        &:hover {
            background: $brand-secondary-darker;
        }
    }
}
</style>
